/// inpired by ChatGPT 
import { defer, of, from, Observable } from 'rxjs';
import { tap, catchError, shareReplay } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { EventId, LogLevel } from './common';
/**
 * get values from API once and store in localStorage, return from localStrorage in subsequent calls
**/
export function cachedObservable<T>(
  http: HttpClient,
  scope: string,
  key: string,
  apiUrl: string,
  logFn?: (level: LogLevel, message: string, eventId?: EventId, data?: { [key: string]: any }) => void
): Observable<T> {
  let cachedValue: T;
  key = `${scope}.${key}`;
  return defer(() => {
    if (cachedValue) return of(cachedValue);

    const storedValue = JSON.parse(localStorage.getItem(key))
    const apiCall = from(http.get<T>(apiUrl)).pipe(
      tap(value => localStorage.setItem(key, JSON.stringify(value))),
      tap(value => (cachedValue = value)),
      catchError(error => {
        if (logFn) logFn(LogLevel.Error, JSON.stringify(error));
        return of(storedValue);
      }),
      shareReplay(1)
    );

    if(storedValue) {
      apiCall.subscribe();
      return of(storedValue);
    }
    else
      return apiCall;

  });
}
